module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "post-listado"
  }, [_h('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(0), " ", _h('tbody', [_vm._l((_vm.posts), function(post) {
    return _h('tr', {
      on: {
        "click": function($event) {
          _vm.abrir(post.key)
        }
      }
    }, [_h('td', [_vm._s(post.fecha)]), " ", _h('td', [_vm._s(post.titulo)]), " ", _h('td', [_vm._s(post.descripcionCorta)])])
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('thead', {
    staticClass: "thead-inverse"
  }, [_h('tr', [_h('th', ["Fecha"]), " ", _h('th', ["Titulo"]), " ", _h('th', ["Descripcion Corta"])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-511520e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Post-Listado.vue
// module id = 199
// module chunks = 2